module.exports = __webpack_public_path__ + "static/media/caio-transparent.329620c4.png";